export default __webpack_public_path__ + "static/media/login.4b70cb17.svg";